import React from 'react';
import {
  Typography, CardMedia, Card,
  Button, CardActions, CardTitle
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { useImpression } from '@thd-olt-component-react/impression';
import ListsHeader from '../ListsHeader';
import { nullStatePropTypes } from './nullStatePropTypes';
import LearnMore from '../LearnMore';

const CompactNullView = ({
  cardBody,
  cardTitle,
  cta,
  imageAlt,
  imageUrl,
  componentId
}) => {

  const { ref, clickID } = useImpression({
    data: {
      component: 'Lists',
      name: 'ListsNullState',
      id: componentId,
      position: 1,
      type: 'content',
    }
  });

  return (
    <Card
      data-component="Lists"
      data-testid="lists"
      className="sui-h-full"
      CardContentProps={{
        className: classNames(
          'sui-flex-col',
          'sui-flex',
          'sui-gap-4',
          'sui-h-full',
          'sui-p-4',
          'sui-w-full'
        )
      }}
    >
      <ListsHeader
        hideActions={false}
        showLearnMoreLink
      />
      <div
        className={
          classNames(
            '@3xl:sui-pr-8',
            '@7xl:sui-max-w-md',
            'sui-flex-col',
            'sui-flex',
            'sui-gap-4',
            'sui-h-full',
            'sui-overflow-hidden',
            'sui-pt-4'
          )
        }
      >
        <CardMedia
          src={imageUrl}
          alt={imageAlt}
          aspect="wide"
        />
        <div
          className={
            classNames(
              '@3xl:sui-pr-8',
              '@7xl:sui-max-w-md',
              'sui-flex-col',
              'sui-flex',
              'sui-gap-4',
              'sui-h-full',
              'sui-pt-4'
            )
          }
        >
          <CardTitle
            header={(
              <Typography
                variant="h2"
                weight="display"
              >
                {cardTitle}
              </Typography>
            )}
          />
          {cardBody}
          {/* eslint-disable-next-line react/no-unknown-property */}
          <div className="sui-flex-end" ref={ref} clickid={clickID}>
            <CardActions>
              <LearnMore variant="button" />
            </CardActions>
          </div>
        </div>
      </div>
    </Card>
  );
};

CompactNullView.propTypes = nullStatePropTypes;

export default CompactNullView;
